<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row v-if="model">

                <rkm-col cols="3">
                    <rkm-area
                        title="Responsável familiar"
                        no-margin-top
                    >
                        <rkm-row>
                            <rkm-col cols="12">
                                <rkm-form-radio-group
                                    v-model="model.responsavel"
                                    :label="false"
                                    @change="handleResponsavel()"
                                    class="pt-0"
                                    :disabled="model.saidaCidadaoId == enums.saidaCidadao.OBITO || isDisabled()"
                                    :validations="validations.responsavel"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-area
                        title="Responsável"
                        no-margin-top
                    >
                        <rkm-row>

                            <rkm-col
                                cols="12"
                                v-if="responsavelFamiliarOptions.length > 0"
                            >
                                <rkm-form-select
                                    :options="responsavelFamiliarOptions"
                                    :label="false"
                                    text-field="nome"
                                    name="Responsável"
                                    v-model="responsavelFamiliarId"
                                    value-field="id"
                                    :disabled="!podeSelecionarResponsavel"
                                    class="pt-0"
                                />
                            </rkm-col>

                            <rkm-col
                                cols="12"
                                v-else
                            >
                                <rkm-form-input
                                    :label="false"
                                    value="Não tem responsável"
                                    disabled
                                    class="pt-0"
                                />
                            </rkm-col>

                        </rkm-row>
                    </rkm-area>
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-area
                        title="Ocupação"
                        no-margin-top
                    >
                        <rkm-row>
                            <rkm-col cols="12">

                                <rkm-form-input-autocomplete
                                    :searchFields="localForm.autocompleteFields.ocupacao"
                                    :repository="repositories.ocupacao"
                                    v-model="model.ocupacao"
                                    :textField="l => `${l.codigo} - ${l.nome}`"
                                    uppercase
                                />

                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>

                <rkm-col cols="12">
                    <rkm-area
                        title="Qual é o curso mais elevado que frequenta ou frequentou?"
                        no-margin-top
                    >
                        <rkm-row>
                            <rkm-col cols="12">

                                <rkm-form-select
                                    :options="form.curso"
                                    :label="false"
                                    show-default-option
                                    text-field="descricao"
                                    v-model="model.cursoId"
                                    default-option-text="Selecione"
                                    value-field="id"
                                    class="pt-0"
                                    :disabled="isDisabled()"
                                >
                                    <rkm-input-group-append slot="append">
                                        <rkm-input-group-text>
                                            <rkm-form-checkbox
                                                v-model="model.frequentaEscolaCreche"
                                                :disabled="isDisabled()"
                                            >
                                                Frequenta escola ou creche
                                            </rkm-form-checkbox>
                                        </rkm-input-group-text>
                                    </rkm-input-group-append>
                                </rkm-form-select>

                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-area
                        title="Situação no mercado de trabalho"
                        no-margin-top
                    >
                        <rkm-row>
                            <rkm-col cols="12">

                                <rkm-form-select
                                    :options="form.mercadoTrabalho"
                                    :label="false"
                                    :disabled="isDisabled()"
                                    show-default-option
                                    text-field="descricao"
                                    v-model="model.situacaoMercadoTrabalhoId"
                                    default-option-text="Selecione"
                                    value-field="id"
                                    class="pt-0"
                                />

                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-area
                        title="Frequenta cuidador tradicional?"
                        no-margin-top
                    >
                        <rkm-row>
                            <rkm-col cols="12">

                                <rkm-form-radio-group
                                    v-model="model.frequentaCuidadorTradicional"
                                    :label="false"
                                    class="pt-0"
                                    :disabled="isDisabled()"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>

                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-area
                        title="Participa de grupo comunitário?"
                        no-margin-top
                    >
                        <rkm-row>
                            <rkm-col cols="12">

                                <rkm-form-radio-group
                                    v-model="model.participaGrupoComunitario"
                                    :label="false"
                                    class="pt-0"
                                    :disabled="isDisabled()"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>

                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-area
                        title="CRIANÇAS DE 0 A 9 ANOS, COM QUEM FICA?"
                        no-margin-top
                    >
                        <rkm-row>
                            <rkm-col cols="12">

                                <rkm-form-checkbox-group
                                    :options="form.acompanhamentoInfantil"
                                    class="mx-2"
                                    name="criancas"
                                    text-field="descricao"
                                    v-model="model.acompanhamentoInfantil"
                                    value-field="id"
                                    :disabled="isDisabled()"
                                />

                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-area
                        title="Plano de saúde privado"
                        no-margin-top
                    >
                        <rkm-row>
                            <rkm-col cols="12">

                                <rkm-form-radio-group
                                    v-model="model.planoSaude"
                                    :disabled="isDisabled()"
                                    label="Possui?"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>

                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>

                <rkm-col cols="9">
                    <rkm-area
                        title="Povo ou comunidade tradicional?"
                        no-margin-top
                    >
                        <rkm-row>

                            <rkm-col cols="4">

                                <rkm-form-radio-group
                                    v-model="model.comunidadeTradicional"
                                    :disabled="isDisabled()"
                                    label="É membro?"
                                    @change="resetComunidadeTradicionalQual()"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>

                            </rkm-col>

                            <rkm-col cols="8">

                                <rkm-form-input-autocomplete
                                    :searchFields="localForm.autocompleteFields.comunidade"
                                    :repository="repositories.cadastroIndividual.comunidade"
                                    v-model="model.comunidadeTradicionalQual"
                                    textField="descricao"
                                    :validations="model.comunidadeTradicional ? validations.comunidadeTradicional : {}"
                                    :disabled="!model.comunidadeTradicional"
                                    label="Qual?"
                                    uppercase
                                />

                            </rkm-col>

                        </rkm-row>
                    </rkm-area>
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-area
                        title="Orientação sexual"
                        no-margin-top
                    >
                        <rkm-row>

                            <rkm-col cols="4">

                                <rkm-form-radio-group
                                    v-model="model.orientacaoSexual"
                                    label="Deseja informar?"
                                    @change="resetOrientacaoSexual()"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>

                            </rkm-col>

                            <rkm-col cols="8">

                                <rkm-form-select
                                    :options="form.orientacaoSexual"
                                    label="Orientação sexual"
                                    show-default-option
                                    text-field="descricao"
                                    v-model="model.orientacaoSexualId"
                                    default-option-text="Selecione"
                                    value-field="id"
                                    :disabled="!model.orientacaoSexual"
                                    :validations="model.orientacaoSexual ? validations.orientacaoSexual : {}"
                                />

                            </rkm-col>

                        </rkm-row>
                    </rkm-area>
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-area
                        title="Identidade de gênero"
                        no-margin-top
                    >
                        <rkm-row>

                            <rkm-col cols="4">

                                <rkm-form-radio-group
                                    v-model="model.identidadeGenero"
                                    label="Deseja informar?"
                                    @change="resetIdentidadeGenero()"
                                    :validations="validations.identidadeGenero"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>

                            </rkm-col>

                            <rkm-col cols="8">

                                <rkm-form-select
                                    :disabled="!model.identidadeGenero"
                                    :options="form.cidadao.identificacao.identidadesGenero"
                                    :validations="model.identidadeGenero ? validations.identidadeGenero : {}"
                                    label="Identidade de gênero"
                                    show-default-option
                                    text-field="descricao"
                                    v-model="model.cidadao.identidadeGeneroId"
                                    value-field="id"
                                />

                            </rkm-col>

                        </rkm-row>
                    </rkm-area>
                </rkm-col>

                <rkm-col cols="12">
                    <rkm-area
                        title="Deficiência"
                        no-margin-top
                    >
                        <rkm-row>

                            <rkm-col cols="3">

                                <rkm-form-radio-group
                                    v-model="model.deficiente"
                                    label="Tem alguma?"
                                    @change="resetDeficiencias()"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>

                            </rkm-col>

                            <rkm-col cols="9">

                                <rkm-form-checkbox-group
                                    :options="form.deficiencia"
                                    label="Quais?"
                                    name="deficiencias"
                                    text-field="descricao"
                                    v-model="model.deficiencias"
                                    value-field="id"
                                    :disabled="!model.deficiente"
                                    :validations="model.deficiente == true ? validations.deficiencia : {}"
                                />

                            </rkm-col>

                        </rkm-row>
                    </rkm-area>
                </rkm-col>

                <rkm-col cols="12">

                    <rkm-area
                        type="fieldset"
                        title="Informação Socioeconômica"
                    >
                        <rkm-row>

                            <rkm-col cols="12">

                                <rkm-form-radio-group
                                    label="Nos últimos três meses, os alimentos acabaram antes que você tivesse dinheiro para comprar mais comida?"
                                    v-model="model.alimentosAcabaram"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                    <rkm-form-radio :value="null">
                                        Não informado
                                    </rkm-form-radio>
                                </rkm-form-radio-group>

                            </rkm-col>

                            <rkm-col cols="12">

                                <rkm-form-radio-group
                                    label="Nos últimos três meses, você comeu apenas alguns alimentos que ainda tinha, porque o dinheiro acabou?"
                                    v-model="model.comeuAlgunsAlimentos"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                    <rkm-form-radio :value="null">
                                        Não informado
                                    </rkm-form-radio>
                                </rkm-form-radio-group>

                            </rkm-col>

                            <rkm-col cols="3">

                                <rkm-form-date-picker
                                    label="Data de atualização"
                                    v-model="model.dataAtualizacaoTria"
                                    disabled
                                    right
                                />

                            </rkm-col>

                        </rkm-row>
                    </rkm-area>

                </rkm-col>

                <rkm-col cols="12">

                    <rkm-area
                        title="Saída do cidadão do cadastro"
                        type="fieldset"
                        no-margin-top
                    >

                        <rkm-row>

                            <rkm-col cols="6">

                                <rkm-form-select
                                    :options="form.saidaCidadao"
                                    label="Motivo"
                                    show-default-option
                                    text-field="descricao"
                                    v-model="model.saidaCidadaoId"
                                    default-option-text="Selecione"
                                    value-field="id"
                                    @change="handleMotivoSaida"
                                    :disabled="model.obito && model.saidaCidadaoId == enums.saidaCidadao.OBITO || isDisabled()"
                                />

                            </rkm-col>

                            <rkm-col
                                cols="6"
                                v-if="model.saidaCidadaoId == enums.saidaCidadao.MUDANCA_DE_TERRITORIO"
                            >

                                <rkm-form-date-picker
                                    label="Data"
                                    :max-date="form.dataAtual"
                                    v-model="model.motivoSaidaData"
                                    :disabled="isDisabled()"
                                    :validations="model.saidaCidadaoId == enums.saidaCidadao.MUDANCA_DE_TERRITORIO ? validations.motivoSaidaData : {}"
                                    right
                                />

                            </rkm-col>

                            <rkm-col
                                v-if="model.saidaCidadaoId == enums.saidaCidadao.OBITO"
                            >

                                <rkm-form-date-picker
                                    label="Data de óbito"
                                    :max-date="form.dataAtual"
                                    v-model="model.obitoEm"
                                    :min-date="dataDocumento"
                                    :validations="model.saidaCidadaoId == enums.saidaCidadao.OBITO ? validations.dataObito : {}"
                                    :disabled="model.obito"
                                    right
                                />

                            </rkm-col>

                            <rkm-col
                                v-if="model.saidaCidadaoId == enums.saidaCidadao.OBITO"
                            >

                                <rkm-form-time-picker
                                    :validations="model.saidaCidadaoId == enums.saidaCidadao.OBITO ? validations.horaObito : {}"
                                    label="Hora de óbito"
                                    v-model="model.horaObito"
                                    :disabled="model.obito"
                                />

                            </rkm-col>

                        </rkm-row>

                        <rkm-row v-if="model.saidaCidadaoId == enums.saidaCidadao.OBITO">

                            <rkm-col>

                                <rkm-form-input
                                    label="Número da declaração de óbito"
                                    v-model="model.obitoDeclaracao"
                                    :validations="model.saidaCidadaoId == enums.saidaCidadao.OBITO ? validations.obitoDeclaracao : {}"
                                    :disabled="model.obito"
                                />

                            </rkm-col>

                            <rkm-col>

                                <rkm-form-input-autocomplete
                                    :searchFields="fields.autocomplete.obito.cid"
                                    :repository="repositories.cid"
                                    label="CID10"
                                    placeholder="CID10 referente a causa do óbito"
                                    v-model="model.obitoCid"
                                    :disabled="model.obito"
                                >
                                    <template v-slot:itemLabel="{ item }">
                                        {{ item.codigo | formatCid }} - {{ item.nome }}
                                    </template>
                                </rkm-form-input-autocomplete>

                            </rkm-col>

                        </rkm-row>

                        <rkm-row v-if="model.saidaCidadaoId == enums.saidaCidadao.OBITO">

                            <rkm-col>

                                <rkm-form-textarea
                                    label="Causa do óbito"
                                    v-model="model.obitoCausa"
                                    :disabled="model.obito"
                                />

                            </rkm-col>

                        </rkm-row>

                    </rkm-area>

                </rkm-col>

                <rkm-col cols="12">

                    <rkm-area
                        title="Recusa do Cadastro Individual da Atenção Básica"
                        type="fieldset"
                        no-margin-top
                    >

                        <rkm-col cols="12">

                            <rkm-form-checkbox
                                :value="true"
                                v-model="model.informacaoSocialRecusaCadastro"
                                @change="handleRecusaCadastro()"
                            >
                                Usuário recusou o cadastro por meio do termo de Recusa do Cadastro
                            </rkm-form-checkbox>

                        </rkm-col>

                    </rkm-area>

                </rkm-col>

            </rkm-row>
        </rkm-form>

        <ModalObito
            ref="ModalObito"
            :data="{ form, model }"
        />

        <ModalTerritorio
            ref="ModalTerritorio"
            :data="{ form, model }"
        />

    </div>
</template>

<script>

import ModalTerritorio from './components/territorio/Modal'
import ModalObito from './components/obito/Modal'

// Enums.
import classificacao from '@/enums/cadastro/paciente/classificacao'
import subclassificacao from '@/enums/cadastro/paciente/subclassificacao'
import permissao from '@/enums/atencao-basica/parametrizacao/permissao'
import tipoAtendimento from '@/enums/atencao-basica/atendimento-individual/tipoAtendimento'
import saidaCidadao from '@/enums/atencao-basica/saidaCidadao'
import deficiencia from '@/enums/cadastro/cidadao/deficienciaBase'
import fatorRisco from '@/enums/cadastro/cidadao/fatorRisco'

// Vuex.
import { mapGetters } from 'vuex'

// Mixins.
import { repository, object } from '@/mixins'

export default {
    components: {
        ModalTerritorio,
        ModalObito
    },

    mixins: [
        repository,
        object
    ],

    props: {
        form: {
            type: Object,
            required: true
        },

        model: {
            type: Object,
            required: true
        },
    },

    created() {

        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            atendimentoIndividual: this.getConectaSusRepository('atencaoBasica.atendimentoIndividual'),
            cadastroIndividual: this.getConectaSusRepository('atencaoBasica.cadastroIndividual'),
            cid: this.getConectaSusRepository('sigtap.cid'),
            ocupacao: this.getConectaSusRepository('sigtap.ocupacao')
        }
    },

    data: () => ({
        enums: {
            classificacao,
            subclassificacao,
            permissao,
            tipoAtendimento,
            saidaCidadao,
            deficiencia,
            fatorRisco
        },

        unidades: [],
        equipes: [],
        infraestruturas: [],
        ocupacoes: [],

        localForm: {
            autocompleteFields: {
                ocupacao: [
                    {
                        key: 'codigo',
                        searchable: true
                    },
                    {
                        key: 'nome',
                        searchable: true
                    },
                ],

                comunidade: [
                    {
                        key: 'codigoEsus',
                        searchable: true
                    },
                    {
                        key: 'descricao',
                        searchable: true
                    },
                ],
            },
        },
    }),

    computed: {

        ...mapGetters({
            cliente: 'getCliente'
        }),

        validations() {

            return {
                responsavel: {
                    required: true
                },

                responsavelFamiliar: {
                    required: true
                },

                orientacaoSexual: {
                    required: true
                },

                identidadeGenero: {
                    required: true
                },

                comunidadeTradicional: {
                    required: true
                },

                deficiencia: {
                    required: true
                },

                obitoDeclaracao: {
                    min: 9,
                    max: 9
                },

                dataObito: {
                    required: true
                },

                horaObito: {
                    required: false
                },

                declaracao: {
                    required: true,
                    numeric: true,
                    min: 8,
                    max: 13
                },

                causa: {
                    required: true,
                    min: 1,
                    max: 250
                },

                cidId: {
                    required: true
                },

                alimentosAcabaram: {
                    required: this.model.comeuAlgunsAlimentos !== null
                },

                comeuAlgunsAlimentos: {
                    required: this.model.alimentosAcabaram !== null
                },
            }
        },

        fields() {

            return {
                autocomplete: {

                    usuario: [
                        {
                            key: "cadastroCidadao.nome",
                            searchable: true
                        },
                        {
                            key: "cadastroUsuario.registroNumero",
                            searchable: true
                        },
                    ],

                    cid: [
                        {
                            key: "nome",
                            searchable: true
                        }
                    ],

                    obito: {
                        cid: [
                            {
                                key: 'codigo',
                                searchable: true
                            },
                            {
                                key: 'nome',
                                searchable: true
                            },
                        ],
                    },
                },
            }
        },

        dataDocumento() {

            const datasExistentes = []

            if (this.model.dataEntrada) {
                datasExistentes.push(new Date(this.model.dataEntrada))
            }

            if (this.model.dataNaturalizacao) {
                datasExistentes.push(new Date(this.model.dataNaturalizacao))
            }

            if (this.model.dataNascimento) {
                datasExistentes.push(new Date(this.model.dataNascimento))
            }

            if (datasExistentes.length > 0) {

                const dataMaisRecente = new Date(
                    Math.max(...datasExistentes)
                )

                return this.getFormatedDate(
                    dataMaisRecente,
                    'DD/MM/YYYY'
                )
            }

            return null
        },
        responsavelFamiliarOptions() {

            if (this.model.responsavel) {

                return [
                    {
                        id: this.model.cidadao.id,
                        nome: this.model.cidadao.nome
                    }
                ]
            }

            return this.form.responsaveis || []
        },
        podeSelecionarResponsavel() {

            if (this.model.responsavel) {
                return false
            }

            const responsaveis = this.form.responsaveis || []

            return responsaveis.length > 1
        },
        responsavelFamiliarId: {

            get() {

                if (this.model.responsavel) {
                    return this.model.cidadao.id
                }

                return this.model.responsavelCidadaoId
            },

            set(value) {

                if (!this.model.responsavel) {
                    this.model.responsavelCidadaoId = value
                }
            },
        },
    },

    methods: {

        validate() {

            return this.$refs.Form.validate()
        },

        limparInformacoesSociais() {

            this.model.saidaCidadaoId = null
            this.model.motivoSaidaData = null
        },

        getMessageClassificacao(id) {

            let message = ''

            switch (id) {

                case this.enums.classificacao.MUNICIPE: {

                    message = `${this.cliente.municipio.nome} com comprovação de endereço`

                    break
                }

                case this.enums.classificacao.PROVISORIO: {

                    message = `${this.cliente.municipio.nome} sem comprovação de endereço`

                    break
                }

                case this.enums.classificacao.OUTRO_MUNICIPIO: {

                    message = 'outro município'

                    break
                }
            }

            return `Este paciente reside em ${message}. Confirma o cadastro?`
        },

        handleSubclassificacaoChange() {

            this.model.periodoValidade.start = null
            this.model.periodoValidade.end = null
        },

        handleResponsavel() {

            if (this.model.responsavel) {

                if (!this.form.domicilioId) {

                    this.model.responsavelCidadaoId = null
                    this.model.parentescoResponsavelId = null

                    return
                }

                const confirmar = async () => {

                    this.model.responsavelCidadaoId = null
                    this.model.parentescoResponsavelId = null
                }

                const cancelar = async () => {

                    this.model.responsavel = false
                }

                if (
                    this.form.responsaveis &&
                    this.form.responsaveis.length > 0
                ) {

                    const nomes = this.form.responsaveis
                        .map(responsavel => responsavel.nome)
                        .join(', ')

                    this.showConfirmation(
                        `${nomes} ${
                            this.form.responsaveis.length > 1
                                ? 'constam'
                                : 'consta'
                        } atualmente como `
                            + `responsável familiar deste núcleo. Ao confirmar, este paciente passará a ser o `
                            + `responsável familiar do núcleo e os demais membros serão atualizados. Deseja continuar?`,
                        confirmar,
                        cancelar,
                    )

                } else {

                    this.showConfirmation(
                        'Ao confirmar, este paciente passará a ser o responsável familiar do núcleo e os '
                            + 'demais membros serão atualizados. Deseja continuar?',
                        confirmar,
                        cancelar,
                    )
                }

            } else {

                const responsaveis = this.form.responsaveis || []

                if (responsaveis.length === 1) {

                    this.model.responsavelCidadaoId = responsaveis[0].id

                } else if (responsaveis.length === 0) {

                    this.model.responsavelCidadaoId = null
                }
            }
        },

        handleMotivoSaida() {

            if (
                this.model.saidaCidadaoId == this.enums.saidaCidadao.OBITO &&
                this.model.responsavel &&
                this.form.responsaveis.length > 0
            ) {

                this.showConfirmation(
                    'O paciente atualmente está registrado como responsável familiar. '
                        + 'Ao registrar o óbito, ele será removido como responsável familiar, e será necessário '
                        + 'informar outro membro da família como responsável. Deseja continuar?',
                    async () => this.handleResponsavelObito(),
                    async () => this.model.saidaCidadaoId = null,
                )

            } else if (
                this.model.saidaCidadaoId == this.enums.saidaCidadao.OBITO &&
                this.model.responsavel &&
                this.form.residentes.length > 1
            ) {

                this.$refs.ModalObito.open()

            } else if (
                this.model.saidaCidadaoId == this.enums.saidaCidadao.MUDANCA_DE_TERRITORIO
            ) {

                this.$emit('mudanca-territorio')

                this.showConfirmation(
                    'A classificação do paciente será alterada para "Provisório", e as informações de endereço do '
                        + 'cadastro do paciente serão perdidas. Deseja continuar?',
                    async () => this.$nextTick().then(() => this.handleDomiciliados()),
                    async () => this.model.saidaCidadaoId = null,
                )
            }
        },

        handleResponsavelObito() {

            this.model.responsavel = false
            this.model.responsavelUsuario = null
            this.model.responsavelData = null
            this.model.responsavelEquipeId = null
            this.model.responsavelInfraestruturaId = null
            this.model.responsavelOcupacaoId = null
            this.model.responsavelUnidadeId = null
            this.model.responsavel = false
        },

        handleDomiciliados() {

            const hasLogradouroId =
                this.model.cidadao.domicilio?.endereco?.logradouro?.id

            if (hasLogradouroId) {

                this.model.cidadao.domicilio.endereco.logradouro.cep = null
                this.model.cidadao.domicilio.endereco.logradouro.id = null
                this.model.cidadao.domicilio.endereco.logradouro.nome = null
                this.model.cidadao.domicilio.endereco.logradouro.tipoNome = null
                this.model.cidadao.domicilio.endereco.logradouro = null
            }

            this.model.cidadao.domicilio.endereco.numero = null
            this.model.cidadao.domicilio.endereco.complemento = null
            this.model.cidadao.domicilio.endereco.latitude = null
            this.model.cidadao.domicilio.endereco.longitude = null
            this.model.cidadao.domicilio.endereco.loteamento = null
            this.model.cidadao.domicilio.endereco.zonaId = null
            this.model.cidadao.domicilio.endereco.referencia = null

            this.model.classificacaoId =
                this.enums.classificacao.PROVISORIO

            this.form.cidadao.endereco.cep = ''

            if (this.form.residentes.length > 0) {
                this.$refs.ModalTerritorio.open()
            }
        },

        resetComunidadeTradicionalQual() {

            if (!this.model.comunidadeTradicional) {
                this.model.comunidadeTradicionalQual = null
            }
        },

        reset() {

            this.model.responsavel = null
            this.model.responsavelCidadaoId = null
            this.model.cursoId = null
            this.model.frequentaEscolaCreche = false
            this.model.situacaoMercadoTrabalhoId = null
            this.model.frequentaCuidadorTradicional = null
            this.model.participaGrupoComunitario = null
            this.model.acompanhamentoInfantil = []
            this.model.planoSaude = null
            this.model.comunidadeTradicional = null
            this.model.comunidadeTradicionalQual = null
            this.model.deficiente = null
            this.model.deficiencias = []
            this.model.orientacaoSexual = null
            this.model.orientacaoSexualId = null
        },

        cancel() {

            this.model.informacaoSocialRecusaCadastro = false
        },

        isDisabled() {

            return this.model.informacaoSocialRecusaCadastro
                ? true
                : false
        },

        syncResponsavelFamiliar() {

            if (this.model.responsavel) {
                return
            }

            const responsaveis = this.form.responsaveis || []

            if (responsaveis.length === 1) {

                this.model.responsavelCidadaoId =
                    responsaveis[0].id

            } else if (responsaveis.length === 0) {

                this.model.responsavelCidadaoId = null
            }
        },

        handleRecusaCadastro() {

            if (this.model.informacaoSocialRecusaCadastro) {

                this.showConfirmation(
                    'Ao marcar que o usuário recusou o cadastro, as informações sociais serão apagadas. Deseja continuar?',
                    async () => this.reset(),
                    async () => this.cancel()
                )
            }
        },

        resetOrientacaoSexual() {

            if (!this.model.orientacaoSexual) {
                this.model.orientacaoSexualId = null
            }
        },

        resetIdentidadeGenero() {

            if (!this.model.identidadeGenero) {
                this.model.cidadao.identidadeGeneroId = null
            }
        },

        resetDeficiencias() {

            if (!this.model.deficiente) {
                this.model.deficiencias = []
            }
        },
    },

    watch: {

        'form.responsaveis': {

            handler() {
                this.syncResponsavelFamiliar()
            },

            deep: true,
            immediate: true,
        },

        'model.cidadao.identidadeGeneroId'(identidadeGeneroId) {

            this.model.identidadeGenero = !!identidadeGeneroId
        },

        'model.deficiencias': function (newValue, oldValue) {

            if (newValue !== oldValue) {

                if (newValue) {

                    const fatorRiscoHasTea =
                        this.model.cidadao.fatoresRisco.find(
                            item => item == this.enums.fatorRisco.TEA
                        )
                            ? true
                            : false

                    const newHasTea =
                        newValue.find(
                            item => item == this.enums.deficiencia.TEA
                        )
                            ? true
                            : false

                    const oldHasTea =
                        oldValue.find(
                            item => item == this.enums.deficiencia.TEA
                        )
                            ? true
                            : false

                    if (
                        fatorRiscoHasTea &&
                        !newHasTea &&
                        oldHasTea
                    ) {

                        const fn = async () => {

                            this.model.deficiencias.push(
                                this.enums.deficiencia.TEA
                            )
                        }

                        const ok = async () => {

                            const index =
                                this.model.cidadao.fatoresRisco.indexOf(
                                    this.enums.fatorRisco.TEA
                                )

                            if (index !== -1) {

                                this.model.cidadao.fatoresRisco.splice(
                                    index,
                                    1
                                )
                            }
                        }

                        this.showConfirmation(
                            'O Transtorno do Espectro Autista será removido dos fatores de risco do paciente. Deseja continuar?',
                            ok,
                            fn,
                        )
                    }

                    if (
                        !fatorRiscoHasTea &&
                        newHasTea &&
                        !oldHasTea
                    ) {

                        const ok = async () =>
                            this.model.cidadao.fatoresRisco.push(
                                this.enums.fatorRisco.TEA
                            )

                        const fn = async () => {

                            const index =
                                this.model.deficiencias.indexOf(
                                    this.enums.deficiencia.TEA
                                )

                            if (index !== -1) {

                                this.model.deficiencias.splice(
                                    index,
                                    1
                                )
                            }
                        }

                        this.showConfirmation(
                            'O Transtorno do Espectro Autista será adicionado nos fatores de risco do paciente. Deseja continuar?',
                            ok,
                            fn,
                        )
                    }
                }
            }
        },
    }
}
</script>